import { useState, useEffect } from "react";
import { userService } from "../services/userService";

interface UserNameProps {
  userId: string;
  fallback?: string;
  className?: string;
}

/**
 * Component that displays a user's name based on their ID
 */
export default function UserName({
  userId,
  fallback,
  className,
}: UserNameProps) {
  const [displayName, setDisplayName] = useState<string>(
    fallback || `User ${userId.substring(0, 8)}...`
  );
  const [isLoading, setIsLoading] = useState<boolean>(true);

  useEffect(() => {
    let isMounted = true;

    const fetchUserName = async () => {
      try {
        const name = await userService.getUserDisplayName(userId);
        if (isMounted) {
          setDisplayName(name);
          setIsLoading(false);
        }
      } catch (error) {
        console.error("Error fetching user name:", error);
        if (isMounted) {
          setIsLoading(false);
        }
      }
    };

    fetchUserName();

    return () => {
      isMounted = false;
    };
  }, [userId]);

  return (
    <span className={className}>
      {isLoading ? (
        <span className="opacity-70">{displayName}</span>
      ) : (
        displayName
      )}
    </span>
  );
}
